var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tabs-page',{attrs:{"tabs":_vm.tabs,"keep-alive":false,"title":"Loyalty Program Management"}})}
var staticRenderFns = []

export { render, staticRenderFns }